export const contextKey = 'contextTerminus';
export const getWrapper = nextAction => fnArgs => nextAction(...fnArgs);
getWrapper.contextKey = contextKey;
